import React, { useState } from 'react';
import { Formik, Form } from 'formik';

import { useAuth } from 'context/auth';

import Circle from 'components/circle';
import Alert from 'components/alert';
import ErrorMessage from 'components/error-message';
import { PageForm } from 'components/layouts';
import Button from 'components/button';
import Field from 'components/field';
import RichText from 'components/rich-text';

import schema from './schema';

import './style.css';

const initialValues = { email: '', password: '', passwordConfirm: '' };

const Signup = () => {
  const [success, setSuccess] = useState();
  const { register } = useAuth();

  const onSubmit = async (values, { setSubmitting, setStatus }) => {
    try {
      const { email, password } = values;
      await register({
        email,
        password,
      });
      setSuccess(true);
    } catch (e) {
      const {
        response: { data },
      } = e;

      setStatus(data.detail);
      console.error(e);
      setSubmitting(false);
    }
  };

  const title = !success ? 'Sign Up' : 'CONFIRM E-MAIL';

  return (
    <>
      <Circle
        className="signup-circle-02"
        theme="white"
        width="400px"
        angle={140}
        distance={32}
        blur={32}
      />
      <PageForm
        className="-signup"
        backTo="/login"
        backToText="Log In"
        title={title}
        background={!success}
        extra={
          success ? null : (
            <p>
              By signing up, I agree to the Tweak Plus Terms & Conditions and
              Privacy Policy.
            </p>
          )
        }
      >
        {success ? (
          <RichText className="signup-success-instructions">
            <p>
              Once you confirm your e-mail, you’ll be able to log-in to your
              Tweak+ account.
            </p>
            <p>
              Thank you for giving Tweak+ the opportunity to help your business
              grow.
            </p>
            <Button href="/login" hierarchy="secondary">
              Login
            </Button>
          </RichText>
        ) : (
          <Formik
            initialValues={initialValues}
            onSubmit={onSubmit}
            validationSchema={schema}
          >
            {({ status }) => (
              <Form>
                {status ? (
                  <Alert
                    className="form-general-errors"
                    type="error"
                    message={status}
                  />
                ) : null}

                <Circle
                  className="signup-circle-01"
                  theme="white"
                  width="600px"
                  angle={320}
                  distance={32}
                  blur={32}
                />

                <ErrorMessage name="email" />
                <Field
                  id="email"
                  name="email"
                  placeholder="Email"
                  type="email"
                />
                <ErrorMessage name="password" />
                <Field
                  id="password"
                  name="password"
                  placeholder="Password"
                  type="password"
                />
                <ErrorMessage name="passwordConfirm" />
                <Field
                  id="password-confirm"
                  name="passwordConfirm"
                  placeholder="Confirm Password"
                  type="password"
                />
                <Button type="submit" hierarchy="secondary">
                  Next
                </Button>
              </Form>
            )}
          </Formik>
        )}
      </PageForm>
    </>
  );
};

export default Signup;
